import { ThunkAction } from 'redux-thunk';
import { StreakWeeklySession } from '@fenderdigital/api-definitions/play';
import { get, remove } from '../lib/streaks';
import {
  StreaksRemoveErrorAction,
  StreaksRemoveSuccessAction,
  StreaksIsLoadingAction,
  StreaksUpdateAnalyticsAction,
  QueueStreaksModalAction,
  StreaksState,
} from '../redux-types/streaks.redux-types';
import { RootState } from '../redux-types/root.redux-types';

const streaksRemoveError = (error: string): StreaksRemoveErrorAction => ({
  error,
  type: 'STREAKS_REMOVE_ERROR',
});

const streaksRemoveSuccess = (results: StreakWeeklySession): StreaksRemoveSuccessAction => ({
  results,
  type: 'STREAKS_REMOVE_SUCCESS',
});

const streaksIsLoading = (): StreaksIsLoadingAction => ({
  type: 'STREAKS_IS_LOADING',
});

const streaksUpdateAnalytics = (
  analytics: StreaksState['analytics'],
): StreaksUpdateAnalyticsAction => ({
  analytics,
  type: 'STREAKS_UPDATE_ANALYTICS',
});

export function removeStreak(): ThunkAction<
  Promise<void>,
  RootState,
  {},
  StreaksIsLoadingAction | StreaksRemoveSuccessAction | StreaksRemoveErrorAction
> {
  return async (dispatch): Promise<void> => {
    dispatch(streaksIsLoading());
    try {
      await remove();
      /**
       * Calls get() to return user data
       * without milestones
       */
      const resp = ((await get()) as unknown) as StreakWeeklySession;
      dispatch(streaksRemoveSuccess(resp));
    } catch (error) {
      const errorMessage = 'Error Removing Streak';
      dispatch(streaksRemoveError(errorMessage));
    }
  };
}

export function updateStreakLessons(): ThunkAction<
  void,
  RootState,
  {},
  StreaksUpdateAnalyticsAction
> {
  return (dispatch, getState): void => {
    const { streaks } = getState();
    const { analytics } = streaks;
    const incrementedValue = { lessonsCompleted: analytics.lessonsCompleted + 1 };
    const data = { ...analytics, ...incrementedValue };
    dispatch(streaksUpdateAnalytics(data));
  };
}

export function updateStreakVideos(): ThunkAction<
  void,
  RootState,
  {},
  StreaksUpdateAnalyticsAction
> {
  return (dispatch, getState): void => {
    const { streaks } = getState();
    const { analytics } = streaks;
    const incrementedValue = { videosWatched: analytics.videosWatched + 1 };
    const data = { ...analytics, ...incrementedValue };
    dispatch(streaksUpdateAnalytics(data));
  };
}

export function resetStreakAnalytics(): ThunkAction<
  void,
  RootState,
  {},
  StreaksUpdateAnalyticsAction
> {
  return (dispatch): void => {
    const data = {
      lessonsCompleted: 0,
      videosWatched: 0,
    };
    dispatch(streaksUpdateAnalytics(data));
  };
}

export function shouldQueueStreaksModal(queueModal: boolean): QueueStreaksModalAction {
  return {
    queStreaksModal: queueModal,
    type: 'STREAKS_MODAL_QUEUE',
  };
}
